import { Fragment } from 'react';
import { Card, Tag, Typography } from 'antd';
import { colLabels, rowDefs, severities } from '../constants';
import { matrixCellClass } from '../utils';
import s from './MatrixTab.module.scss';

const { Text } = Typography;

export function MatrixTab() {
  return (
    <Card size="small" classNames={{ body: s['root__matrix-card-body'] }}>
      <Text className={s['root__matrix-title']}>Матрица рисков 5×5</Text>
      <div className={s['root__matrix-grid']}>
        <div className={s['root__matrix-corner']} />
        {colLabels.map((l) => (
          <div key={l} className={s['root__matrix-col-head']}>
            {l}
          </div>
        ))}
        {rowDefs.map(({ p, label }) => (
          <Fragment key={p}>
            <div className={s['root__matrix-row-label']}>{label}</div>
            {severities.map((t) => {
              const v = p * t;
              return (
                <div key={`${p}-${t}`} className={`${s['root__matrix-cell']} ${matrixCellClass(v)}`}>
                  {v}
                </div>
              );
            })}
          </Fragment>
        ))}
      </div>
      <div className={s.root__legend}>
        <Tag color="success">1–4 Низкий</Tag>
        <Tag color="warning">5–9 Средний</Tag>
        <Tag color="error">10–16 Высокий</Tag>
        <Tag color="volcano">17+ Критический</Tag>
      </div>
    </Card>
  );
}
